// extracted by mini-css-extract-plugin
export default {"achievementsTablet":"achievementsTablet_Dj8mo","title":"title_cwmGE","list":"list_jamNf","item":"item_typbu","button":"button_bF70I"};